<p-card class="p-card" header="Subscriptions">
  <p-table
    stripedRows
    [value]="subscriptions"
    responsiveLayout="scroll"
    selectionMode="single"
    [(selection)]="selectedSubscription">
    <ng-template #emptymessage>
      <tr>
        <td colspan="5">No subscriptions found.</td>
      </tr>
    </ng-template>

    <!-- Table Header -->
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>Plan</th>
        <th>Next Due</th>
        <th style="text-align: right">Months</th>
        <th style="text-align: right">Amount</th>
        <th style="text-align: right">Discounted Amount</th>
        <th>Status</th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-rowData>
      <tr [pSelectableRow]="rowData">
        <td>
          <a
            *ngIf="rowData.id"
            [routerLink]="['/admin/subscriptions/view', rowData.id]"
            class="text-blue-600 hover:underline">
            {{ rowData.plan.name }}
          </a>
          <span *ngIf="!rowData.id">
            {{ rowData.plan.name }}
          </span>
        </td>
        <td>{{ rowData.next_due | date }}</td>
        <td style="text-align: right">{{ rowData.months_to_bill }}</td>
        <td style="text-align: right">{{ rowData.amount | currency : "USD" }}</td>
        <td style="text-align: right">{{ rowData.actual_amount | currency : "USD" }}</td>
        <td>
          <span [ngClass]="rowData.is_active ? 'green' : 'red'">
            {{ rowData.is_active | boolToText }}
          </span>
          </td>
        </tr>
    </ng-template>
  </p-table>
</p-card>
